import { render, staticRenderFns } from "./DocumentsReport.vue?vue&type=template&id=2765d065"
import script from "./DocumentsReport.vue?vue&type=script&lang=js"
export * from "./DocumentsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports